'use strict';

var scriptSrc = document.currentScript;

function init() {
  requirejs.config({
    paths: {
      css: 'css/',
      jquery: 'lib/jquery',
      leaflet: 'vendor/leaflet/dist/leaflet-src',
      sortable: '../node_modules/sortablejs/Sortable',
    },
  });

  addStyleTagToHead('main.css');

  //Start map
  var webgisDiv = document.querySelector('.hav-webgis');
  var configPath = webgisDiv.getAttribute('config');
  webgisDiv.setAttribute('id', 'map0');
  requirejs([configPath, 'app/mapifyer'], function(config, Mapifyer) {
    Mapifyer.createMap('map0', configPath);
  });
}

function addStyleTagToHead(path) {
  var config = requirejs.s.contexts._.config;
  var link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = config.baseUrl + config.paths.css + path;
  document.getElementsByTagName('head')[0].appendChild(link);
}

// Get main tag IE fix
function startApplicationIfReady() {
  // Get main tag
  if (scriptSrc === undefined) {
    var jsScriptTags = document.getElementsByTagName('script');

    for (var i = 0; i < jsScriptTags.length; i++) {
      var pattern = /main.js/i;
      if (pattern.test(jsScriptTags[i].getAttribute('src'))) {
        scriptSrc = jsScriptTags[i];
        init();
      } else {
        if (scriptSrc === undefined) {
          setTimeout(function() {
            startApplicationIfReady();
          }, 100);
        }
      }
    }
  } else {
    init();
  }
}

startApplicationIfReady();

define("main", function(){});

